export const MsInSecond: number = 1000
